import { Instagram, BookOpen } from "lucide-react";
import brandIcon from "@/assets/icons/favicon-48.webp";

const links = [
  {
    label: "Mini-Series Releasing Soon",
    icon: BookOpen,
    testid: "footer-read-link",
  },
  {
    label: "@andrewandthemachines",
    href: "https://instagram.com/andrewandthemachines",
    icon: Instagram,
    testid: "footer-instagram-link",
  },
];

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="border-t border-white/10 px-6 py-16 sm:px-12">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-10 text-center">
        <img
          src={brandIcon}
          width="48"
          height="48"
          alt="Andrew Meets the machines logo"
          loading="lazy"
          decoding="async"
          className="h-12 w-12 rounded-sm border border-neon/40 object-cover"
        />
        <p className="font-display text-xl font-bold uppercase tracking-tight sm:text-2xl">
          Andrew Meets <span className="text-neon">the Machines</span>
        </p>

        <nav className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
          {links.map(({ label, href, icon: Icon, testid }) =>
            href ? (
              <a
                key={href}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={testid}
                className="group inline-flex items-center gap-2 border border-white/10 px-5 py-3 font-mono text-xs font-bold uppercase tracking-[0.2em] text-ash transition-colors duration-200 hover:border-neon hover:text-neon"
              >
                <Icon className="h-4 w-4 transition-transform duration-200 group-hover:scale-110" />
                {label}
              </a>
            ) : (
              <span
                key={label}
                data-testid={testid}
                className="inline-flex items-center gap-2 border border-white/10 px-5 py-3 font-mono text-xs font-bold uppercase tracking-[0.2em] text-ash"
              >
                <Icon className="h-4 w-4" />
                {label}
              </span>
            )
          )}
        </nav>

        <div className="space-y-2">
          <p className="font-mono text-xs font-light text-ash">
            A one-human writing and acting project by andrew.insf · The Bay
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-ash/80">
            © {new Date().getFullYear()} Andrew Meets the Machines · End of transmission
          </p>
        </div>
      </div>
    </footer>
  );
}
